import { Avatar, AvatarProps } from '@optiro/ui';

interface AccountAvatarProps extends Omit<AvatarProps, 'src' | 'name'> {
  photoUrl: string | null | undefined;
  name: string;
}

const isFallbackUrl = (url: string) => url.includes('fallback');

const AccountAvatar = ({ photoUrl, name, ...props }: AccountAvatarProps) => {
  const src = photoUrl && !isFallbackUrl(photoUrl) ? photoUrl : null;

  return <Avatar src={src} name={name} color="initials" {...props} />;
};

export { AccountAvatar };
